import { render, staticRenderFns } from "./NeumaticoForm.vue?vue&type=template&id=0f5d4e14"
import script from "./NeumaticoForm.vue?vue&type=script&lang=ts"
export * from "./NeumaticoForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports